import React, { useState } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import cx from "classnames";

import { useOrganizationList } from "modules/serviceRegister/hooks";
import { MANDATORY_CATEGORY_TYPE } from "modules/mandatoryRequirement/constants";

import * as Grid from "components/Grid";

import StatCard from "components/Card";
import Spacer from "components/Spacer";
import Button from "components/Button";
import Container from "components/Container";

import cls from "./Tabs.module.scss";
import { LoadingOutlined } from "@ant-design/icons";

const Tabs = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [type, setType] = useState(MANDATORY_CATEGORY_TYPE.ORGANIZATION_STATS);

  const { items: statItems, isFetched: isStatsFetched } = useOrganizationList({
    enabled: true,
    params: {
      perPage: 8,
    }
  });

  return (
    <section className={cls.section}>
      <Container>
        <div className={cls.tabs}>
            <div
              className={cx(cls.tab, type === MANDATORY_CATEGORY_TYPE.ORGANIZATION_STATS && cls.tabActive)}
              onClick={() => setType(MANDATORY_CATEGORY_TYPE.ORGANIZATION_STATS)}
              key={MANDATORY_CATEGORY_TYPE.ORGANIZATION_STATS}
            >
              {t(`mandatory_${MANDATORY_CATEGORY_TYPE.ORGANIZATION_STATS}`)}
            </div>
        </div>

        <Spacer size={50} />

        <Grid.Row gutter={[16, 16]}>
          {type === MANDATORY_CATEGORY_TYPE.ORGANIZATION_STATS && statItems
            .map((item, index) => (
              <Grid.Col span={6} key={item.id} data-aos="fade-up" data-aos-delay={index * 100}>
                <StatCard
                  id={item.id}
                  name={item.name[i18n.language]}
                  uuid={item.file_response.uuid}
                  count={item.count}
                  onClick={() => navigate(`/service-register/list?organization_id=${item.id}`)}
                />
              </Grid.Col>
            ))}

          {type === MANDATORY_CATEGORY_TYPE.ORGANIZATION_STATS && !isStatsFetched && (
            <div className={cls.loading}>
              <LoadingOutlined />
            </div>
          )}
        </Grid.Row>

        {statItems.length > 0 && type === MANDATORY_CATEGORY_TYPE.ORGANIZATION_STATS && (
          <div className={cls.btn}>
            <Button onClick={() => navigate('/service-organizations')}>
              {t('action_more')}
            </Button>
          </div>
        )}
      </Container>
    </section>
  )
}

export default Tabs;